interface SuggestSortable {
    liked?: boolean
    internalNote?: string
}

export function sortBySuggestPriority(a: SuggestSortable, b: SuggestSortable): number {
    const likedDiff: number = (b.liked ? 1 : 0) - (a.liked ? 1 : 0)
    if (likedDiff !== 0) {
        return likedDiff
    }
    return (b.internalNote?.length || 0) - (a.internalNote?.length || 0)
}
